import { ReactElement, useEffect } from 'react'
import {
  PageWrapper,
  SectionTitle,
  FlexWrapper,
  DropdownWrapper,
  EditableDropdown,
  TableWrapper,
  TableHeader,
  TableRow,
  Icon,
  Loader
} from '../../../components'
import strings from '../../../locale/en'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import { getCoursesDropdown, getInstituteDropdown } from '../../../helpers'
import { getInstitutes } from '../../../redux/coachingCenter/actions'
import {
  getChildByInstitute,
  getChildCourses,
  getMaterialByTopic
} from '../../../redux/course/action'
import Table from 'react-bootstrap/Table'
import { tableHeader } from './const'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormBackWrapper } from '../User/subcomponents'

const Material = (): ReactElement => {
  const {
    institutes,
    courses,
    subjects,
    chapters,
    topics,
    materials,
    isLoading
  } = useSelector(
    (state: RootState) => ({
      institutes: state.coachingCenter.institutes,
      courses: state.course.courses,
      subjects: state.course.subjects,
      chapters: state.course.chapters,
      topics: state.course.topics,
      materials: state.course.materials,
      isLoading: state.course.isLoading
    }),
    shallowEqual
  )
  const dispatch = useDispatch()

  const {
    menu: {
      admin: {
        materialListing,
        instituteName,
        selectCourse,
        selectSubject,
        selectChapter,
        selectTopic
      }
    }
  } = strings

  const instituteList = institutes ? getInstituteDropdown(institutes) : []
  const courseList = courses ? getCoursesDropdown(courses) : []
  const subjectList = subjects ? getCoursesDropdown(subjects) : []
  const chapterList = chapters ? getCoursesDropdown(chapters) : []
  const topicList = topics ? getCoursesDropdown(topics) : []

  useEffect(() => {
    dispatch(getInstitutes())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <SectionTitle title={materialListing} hasBorder />
      <FlexWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={instituteList || []}
            title={instituteName}
            placeholder={instituteName}
            isRequired
            handleSelect={(item) => {
              dispatch(getChildByInstitute({ instituteId: item.id }))
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={courseList}
            title={selectCourse}
            placeholder={selectCourse}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              dispatch(getChildCourses({ courseId: item.id, type: 'SUBJECT' }))
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={subjectList}
            title={`${selectSubject}`}
            placeholder={selectSubject}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              dispatch(getChildCourses({ courseId: item.id, type: 'CHAPTER' }))
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={chapterList}
            title={`${selectChapter}`}
            placeholder={selectChapter}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              dispatch(getChildCourses({ courseId: item.id, type: 'TOPIC' }))
            }}
          />
        </DropdownWrapper>
        <DropdownWrapper>
          <EditableDropdown
            dropdownList={topicList}
            title={`${selectTopic}`}
            placeholder={selectTopic}
            isRequired
            isDisabled={false}
            handleSelect={(item) => {
              dispatch(getMaterialByTopic({ topicId: item.id }))
            }}
          />
        </DropdownWrapper>
      </FlexWrapper>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <FormBackWrapper>
            <TableWrapper>
              <Table size="sm" responsive="sm">
                <TableHeader>
                  <TableRow>
                    {tableHeader?.map((header, index) => (
                      <th key={`question-list-header-${index}`}>{header}</th>
                    ))}
                  </TableRow>
                </TableHeader>
                <tbody>
                  {materials?.map((material, index) => {
                    const {
                      title,
                      description,
                      materialType,
                      orderSequence,
                      status
                    } = material || {}
                    return (
                      <TableRow key={`material-${index}`}>
                        <td>{title}</td>
                        <td>{description}</td>
                        <td>{materialType}</td>
                        <td>{orderSequence}</td>
                        <td>{status}</td>
                        <td>
                          <Icon variant="outline-light" onClick={() => { }}>
                            <FontAwesomeIcon
                              icon={['far', 'trash-alt']}
                              style={{ marginRight: 10 }}
                            />
                          </Icon>
                          <Icon variant="outline-light" onClick={() => { }}>
                            <FontAwesomeIcon
                              icon={['far', 'eye']}
                              style={{ marginRight: 10 }}
                            />
                          </Icon>
                          <Icon variant="outline-light" onClick={() => { }}>
                            <FontAwesomeIcon
                              icon={['far', 'edit']}
                              style={{ marginRight: 10 }}
                            />
                          </Icon>
                        </td>
                      </TableRow>
                    )
                  })}
                </tbody>
              </Table>
            </TableWrapper>
          </FormBackWrapper>
        </div>
      )}
    </PageWrapper>
  )
}

export default Material
